import React from "react";
import { getName } from "../../utils/utilityFunctions/stringUtility";
import expandButton from "../../assets/images/ExpandButton.svg";
import { getDateYYYYMMDD } from "../../utils/utilityFunctions/dateConvert";
const JobSummary = ({ formData, handleChangeStatusWIP }) => {
  const jobSummaryList = [
    {
      id: 1,
      name: "Link To Service",
      value: formData?.service_id,
      textColor: "",
    },
    {
      id: 2,
      name: "Status",
      value: formData?.status,
      textColor: "",
    },
    {
      id: 3,
      name: "Job Period",
      value: getDateYYYYMMDD(formData?.end_date),
      textColor: "",
    },
    {
      id: 4,
      name: "Target Delivery Date",
      value: getDateYYYYMMDD(formData?.target_delivery_date),
      textColor: "",
    },
    {
      id: 5,
      name: "Budgeted Hours",
      value: formData?.budgeted_hours,
      textColor: "",
    },
  ];
  return (
    <div className="p-3">
      <div className="p-2 col-span-2 border border-[#D2DAE1] rounded-md w-full">
        <h5>Job Title : {formData?.subject}</h5>
        <table className="w-full">
          {jobSummaryList?.map((eachDetail, i) => (
            <tr>
              <td className="text-[#848687] font-300 text-xs">{getName(eachDetail?.name)}</td>
              <td className="text-[#2C495D] font-400 text-sm">
                <span className="text-[#848687] font-300 text-xs mr-3">:</span>
              </td>
              <td className="text-[#2C495D] font-400 text-sm" style={{ color: `${eachDetail?.textColor}` }}>
                {getName(eachDetail?.value)}
              </td>
              {i === 0 && (
                <td>
                  <button type="button">
                    <img src={expandButton} onClick={handleChangeStatusWIP} />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

export default JobSummary;
